module.exports = __webpack_public_path__ + "static/media/screen-collection.fd766cf3.svg";